const buttons = [
  {
    title: "Babysitting",
    subtitle: "",
    formTitle: "Babysitting Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Details",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  {
    title: "Dog Walking/Pet Sitting",
    subtitle: "",
    formTitle: "Dog Walking/Pet Sitting Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "type",
        label: "Type",
        type: "checkbox_group",
        options: [
          { value: "Dog Walking", label: "Dog Walking" },
          { value: "Pet Sitting", label: "Pet Sitting" },
          { value: "Other", label: "Other" },
        ],
        optional: true,
        order: 5,
      },
      {
        name: "notes",
        label: "Notes",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  {
    title: "Academic Tutoring",
    subtitle: "",
    formTitle: "Academic Tutoring Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      {
        name: "subject",
        label: "Subject",
        type: "dropdown",
        order: 3,
        placeholder: "Choose a subject",
        options: [
          { value: "math", label: "Math" },
          { value: "science", label: "Science" },
          { value: "english", label: "English" },
          { value: "spanish", label: "Spanish" },
          { value: "other", label: "Other" },
        ],
      },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Notes",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  {
    title: "Private Lessons",
    subtitle: "Music, Sports, Arts",
    formTitle: "Private Lessons Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      {
        name: "activity",
        label: "Activity",
        type: "dropdown",
        order: 3,
        placeholder: "Choose an activity",
        options: [
          { value: "baseball", label: "Sports: Baseball" },
          { value: "basketball", label: "Sports: Basketball" },
          { value: "soccer", label: "Sports: Soccer" },
          { value: "football", label: "Sports: Football" },
          { value: "chess", label: "Sports: Chess" },
          { value: "piano", label: "Music: Piano" },
          { value: "violin", label: "Music: Violin" },
          { value: "cello", label: "Music: Cello" },
          { value: "clarinet", label: "Music: Clarinet" },
          { value: "trumpet", label: "Music: Trumpet" },
          { value: "guitar", label: "Music: Guitar" },
          { value: "painting", label: "Art: Painting" },
          { value: "drawing", label: "Art: Drawing" },
          { value: "other", label: "Other" },
        ],
      },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Notes",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },

  {
    title: "Yard Work",
    subtitle: "Mowing, weeding, gardening",
    formTitle: "Yard Work Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Notes",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  {
    title: "Housework",
    subtitle: "Cleaning, moving, general help",
    formTitle: "Housework Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Notes",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  /*
    {
      title: "Snow Shoveling",
      subtitle: "",
      formTitle: "Snow Shoveling Request",
      formFields: [
        { name: "address", label: "Address", type: "address", order: 1 },
        { name: "name", label: "Name", type: "text", order: 2 },
        { name: "when", label: "When", type: "date_time", order: 3 },
      ],
    },
    */
  {
    title: "Car Cleaning",
    subtitle: "",
    formTitle: "Car Cleaning Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Notes",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  {
    title: "Power Washing",
    subtitle: "Patios, driveways, garbage cans, etc.",
    formTitle: "Power Washing Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Details",
        type: "notes",
        optional: true,
        order: 7,
      },
    ],
  },
  {
    title: "Other",
    subtitle: "Custom requests",
    formTitle: "Other Request",
    formFields: [
      { name: "name", label: "Your Name", type: "text", order: 1 },
      { name: "address", label: "Address", type: "address", order: 2 },
      { name: "email", label: "Email Address", type: "email", order: 3 },
      {
        name: "phone",
        label: "Phone Number",
        type: "tel",
        order: 4,
        optional: true,
      },
      {
        name: "preferred_contact",
        label: "Preferred Way to Contact",
        type: "checkbox_group",
        options: [
          { value: "email", label: "Email" },
          { value: "call", label: "Call" },
          { value: "text", label: "Text" },
        ],
        order: 5,
      },
      {
        name: "notes",
        label: "Job Description",
        type: "notes",
        optional: false,
        order: 7,
      },
    ],
  },
];
export default buttons;
